<template>
    <div class="container-fluid mt-2">
        <div class="card border-secondary mb-3" >
            <div class="card-header bg-light">
                <div class="row">
                    <div class="col text-dark pt-1">
                        <button type="button" class="btn btn-success pull-left btn-sm" @click="backPage()">ย้อนกลับ</button>
                        <span class="badge rounded-pill bg-warning text-dark py-2 px-4" style="font-size:18px; background:white">
                        <b>Lab Result Entry : ป้อนผลแล็บ</b></span>
                    </div>
                </div>
            </div>
            <div class="card-body" >
                <div class="container-fluid">
                  <div class="row mb-2">
                    <div class="col text-start">
                      <span class="badge rounded-pill bg-info me-1"> BP : <b> {{curRecordHd.BP_1}}/{{curRecordHd.BP_2}} </b> mmHg. </span>
                      <span class="badge rounded-pill bg-info me-1"> Pulse : {{curRecordHd.Pulse}} bpm. </span>
                      <span class="badge rounded-pill bg-info me-1"> Weight : {{curRecordHd.Weight}} kg.</span>
                      <span class="badge rounded-pill bg-info me-1"> Height : {{curRecordHd.Height}} cm.</span>
                      <span class="badge rounded-pill bg-info me-1"> Body temp. : {{curRecordHd.BodyTemp}} C</span>
                      <span class="badge rounded-pill bg-info me-3"> SpO2 : {{curRecordHd.SpO2}} %</span>
                      <span class="badge rounded-pill bg-secondary me-1"> Specimen : {{curRecordHd.Specimen}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-10 text-start">
                      <span class="mx-2">เอกสาร : <b><u>{{curRecordHd.RONo}}</u></b> </span> <span class="mx-2">บัตรปชช : {{curRecordHd.IDNo}}</span>
                      <span class="mx-2">ชื่อ / นามสกุล : <b><u> {{curRecordHd.PrefixName}}{{curRecordHd.PatName}} {{curRecordHd.PatLName}} </u> </b></span>
                      <span class="mx-2">เพศ : <b><u> {{arrSex[curRecordHd.Sex]}} </u></b></span>
                      <span class="mx-2">อายุ : <b><u> {{curRecordHd.AgeYears}}.{{ curRecordHd.AgeMonths }} </u></b> &nbsp; ปี</span>
                      <button type="button" v-if="datalists.length==0" class="btn btn-warning btn-sm me-1" @click="initialItemsLabResult()" title="เตรียมข้อมูลเทสทั้งหมดในใบสั่งตรวจนี้">Initial</button>
                    </div>
                    <div class="col-2">
                        <button type="button" v-if="datalists.length>0" class="btn btn-danger btn-sm float-sm-end" @click="clearAllItemsLabResult()" title="ลบรายการเทสทั้งหมด เพื่อ initial ใหม่">Clear all</button>
                    </div>
                  </div>
                </div>
                <div class="container-fluid mt-2">
                    <form id="formRowsToEditTable" @submit.prevent="">
                        <table id="myEntryResultTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                            <thead class="text-white" style="background:Navy">
                            <tr>
                                <th>ชุดตรวจ</th>
                                <th>เทส</th>
                                <th>เครื่องหมาย</th>
                                <th>ผลแล็บ</th>
                                <th></th>
                                <th>ตรวจซ้ำ</th>
                                <th>ค่าปกติ</th>
                                <th>Min Value</th>
                                <th>Max Value</th>
                                <th>หน่วย</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in datalists" :key="item.RODtl2ID" class="my-edit-tr">
                                <!-- id และ ValueType : สำหรับใช้เป็น key ในการบันทึกผลและแยกประเภทข้อมูลแต่ละเทส -->
                                <input type="text text-info" hidden class="form-control my-edit-input" name="id" :value="item.RODtl2ID">
                                <input type="text text-info" hidden class="form-control my-edit-input" name="ValueType" :value="item.ValueType">

                                <td class="text-start">
                                  <span class="badge bg-secondary me-1">{{item.RoomtypeName}}</span>{{ item.TestName }}
                                  <span class="text-danger" style="font-size:80%;" v-if="item.PropackName"> {{item.PropackName}} </span>
                                </td>
                                <td class="text-start text-primary" v-if="(item.PrintUL==0)"> &nbsp; {{ item.ItemTestName }}</td>
                                <td class="text-start text-primary" v-else><b>{{ item.ItemTestName }}</b></td>
                                <td class="text-start px-3">
                                  <input type="text text-info" class="form-control my-edit-input" name="PrefixResult"
                                    v-if="(item.PrintUL==0)"
                                    v-model="datalists[index].PrefixResult"
                                    maxlength="2" size="2" title="เครื่องหมายนำหน้าผลแล็บ เช่น >,<,>=,<=">
                                </td>
                                <td class="text-start">
                                    <div class="input-group mb-3">
                                        <input type="text text-info my-edit-input" class="form-control" name="Result" title="ผลแล็บเป็นตัวเลข ไม่ต้องป้อนคอมม่าคั่นหลักพัน"
                                          v-if="item.ValueType == 0 && (item.PrintUL == 0)" v-model="datalists[index].Result">
                                        <textarea class="form-control my-edit-input" rows="1" name="Result"
                                          v-if="item.ValueType == 1 && (item.PrintUL == 0)" v-model="datalists[index].ResultText"></textarea>
                                        <select class="form-select form-select-sm my-edit-input" name="Result"
                                          v-if="item.ValueType == 2 && (item.PrintUL == 0)" :value="datalists[index].Result" v-model="datalists[index].Result">
                                            <option disabled value="">Open this select menu</option>
                                            <option v-for="row in itemsOfValueList(item.ValueList)" :key="row" :value="row">{{row}}</option>
                                        </select>
                                        <!-- ปุ่มคำนวณสมการ eGFR -->
                                        <button class="btn btn-warning" type="button" title="กดเพื่อคำนวณค่า eGFR อัตโนมัติตามสูตรคำนวณ CKD-EPI formula"
                                          v-if="globalCorpInfo.eGFR_ID==item.ItemTestID"
                                          @click="calculate_eGFR(datalists, index)">eGFR</button>
                                        <!-- ปุ่มคำนวณสมการ A/G Ratio และ Globulin -->
                                        <button class="btn btn-warning" type="button" title="กดเพื่อคำนวณค่า Globulin อัตโนมัติตามสูตร Globulin = Total_protein - Albumin"
                                          v-if="globalCorpInfo.Globulin_ID==item.ItemTestID"
                                          @click="calculate_Globulin(datalists, index)">Globulin</button>
                                        <button class="btn btn-warning" type="button" title="กดเพื่อคำนวณค่า A/G Ratio อัตโนมัติตามสูตร A/G Ratio = Albumin / (Total_protein - Albumin)"
                                          v-if="globalCorpInfo.AGRatio_ID==item.ItemTestID"
                                          @click="calculate_AGRatio(datalists, index)">A/G Ratio</button>
                                        <!-- ปุ่มคำนวณสมการ LDL -->
                                        <button class="btn btn-warning" type="button" title="กดเพื่อคำนวณค่า LDL อัตโนมัติตามสูตร LDL = TC - HDL - (TG/5) ; Only if TG < 400 mg/ml) "
                                          v-if="globalCorpInfo.LDL_ID==item.ItemTestID"
                                          @click="calculate_LDL(datalists, index)">LDL-C</button>
                                        <!-- ปุ่มคำนวณสมการ eAG (21.11.66 คุณธนกิจแจ้งมา)  -->
                                        <button class="btn btn-warning" type="button" title="กดเพื่อคำนวณค่า eAG อัตโนมัติตามสูตร eAG = (28.7* HbA1c) -  46.7 "
                                          v-if="globalCorpInfo.eAG_ID==item.ItemTestID"
                                          @click="calculate_eAG(datalists, index)">eAG</button>
                                        <!-- ปุ่มคำนวณสมการ Differential WBC Count = 100% -->
                                        <button class="btn btn-warning text-danger" type="button" title="กดเพื่อตรวจสอบผลรวม Differential WBC Count = 100% "
                                          v-if="globalCorpInfo.Neutrophil_ID==item.ItemTestID || globalCorpInfo.Eosinophil_ID==item.ItemTestID ||
                                                globalCorpInfo.Basophil_ID==item.ItemTestID || globalCorpInfo.Lymphocyte_ID==item.ItemTestID ||
                                                globalCorpInfo.Monocyte_ID==item.ItemTestID || globalCorpInfo.AtypicalLymp_ID==item.ItemTestID"
                                          @click="calculate_DiffWBC_Chk100(datalists, index)"><b>ChkSum 100%</b></button>
                                        <!-- แสดงให้ทราบว่าเป็น input ที่เกี่ยวข้องกับการคำนวณสมการ -->
                                        <h6 v-if="globalCorpInfo.Cr_ID==item.ItemTestID ||
                                                  globalCorpInfo.Albumin_ID==item.ItemTestID || globalCorpInfo.TotalProtein_ID==item.ItemTestID ||
                                                  globalCorpInfo.TC_ID==item.ItemTestID || globalCorpInfo.HDL_ID==item.ItemTestID ||
                                                  globalCorpInfo.TG_ID==item.ItemTestID ||
                                                  globalCorpInfo.HbA1C_ID==item.ItemTestID">
                                          <span class="badge bg-secondary">INPUT</span>
                                        </h6>
                                    </div>
                                </td>
                                <td class="text-center" style="width:80px;">
                                  <button v-if="item.ValueType == 1 && (item.PrintUL == 0)" class="btn btn-sm btn-outline-primary py-0 mx-1" id="Remove" title="ป้อนผลตรวจจาก PreResult"
                                    data-bs-toggle="modal" data-bs-target="#addPreResultModal" @click="btnAddPreResultClicked(index, item.TextValueList)"><b>+</b></button>
                                  <button v-if="item.ValueType == 1 && (item.PrintUL == 0)" class="btn btn-sm btn-outline-danger py-0" id="Remove" title="ลบข้อความผลตรวจทั้งหมด" @click="clearTextResultAll(index)">x</button>
                                </td>
                                <td class="">
                                    <select class="form-select form-select-sm" name="RepeatChecked"
                                      v-if="(item.PrintUL == 0)"
                                      v-model="datalists[index].RepeatChecked" >
                                      <option :value="0" title="Not Repeat">N/R</option>
                                      <option :value="1" title="Repeat Checked">R</option>
                                    </select>
                                    <!-- <input class="form-check-input my-edit-input" type="checkbox" name="RepeatChecked" v-model="datalists[index].RepeatChecked"> -->
                                </td>
                                <td class="text-start">{{ item.NormalValue }} </td>
                                <td class="text-start">{{ item.MinValue }}</td>
                                <td class="text-start">{{ item.MaximumValue }}</td>
                                <td class="text-start">{{ item.Unit }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="row">
                          <div class="col-sm">
                            <div class="input-group input-group-sm mb-1">
                                <div class="input-group-prepend">
                                  <label for="Remark" class="input-group-text" style="width:120px;">หมายเหตุ :</label>
                                  <!-- <span class="input-group-text" style="width:120px;">หมายเหตุ :</span> -->
                                </div>
                                <textarea id="Remark" ref="taRemark" name="Remark" rows="3" cols="70" class="px-1" style="resize: both;" v-model="curRecordHd.Remark"></textarea>
                                <button class="btn btn-sm btn-outline-primary px-3" id="" title="เลือกหมายเหตุจากรายการที่เตรียมไว้"
                                  data-bs-toggle="modal" data-bs-target="#addRemarkModal" @click="btnAddRemarkClicked()"><b>+</b></button>
                                <!-- <input type="text" class="form-control form-control-sm" ref="Remark" name="Remark" v-model="curRecordHd.Remark"> -->
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm">
                            <div class="input-group input-group-sm mb-1">
                                <p style="margin-left:120px; font-size:80%;" name="charsCnt">{{_RemarkCharsCnt}} ตัวอักษร</p>
                                <!-- <input type="text" class="form-control form-control-sm" ref="Remark" name="Remark" v-model="curRecordHd.Remark"> -->
                            </div>
                          </div>
                        </div>
                    </form>
                    <button type="button" class="btn btn-primary mx-1" id="SaveAll" @click="saveAllRows()">บันทึกทั้งหมด</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal เพิ่ม PreResult ของชุดตรวจรายการปัจจุบัน -->
    <div id="addPreResultModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Add Pre-Result | เพิ่ม</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container-fluid p-2 border border-1 border-secondary " style="height: 400px;">
                <div class="mh-100 vh-100 overflow-auto ">                <ul class="list-group">
                  <li v-for="item in dataPreResultlists.split(',')" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                      {{item}}
                      <span class="btn badge bg-primary rounded-pill" title="เพิ่ม"  @click="addPreResult(item)">Add</span>
                  </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal เพิ่ม Remark -->
    <div id="addRemarkModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Add Remark | เพิ่ม</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container-fluid p-2 border border-2 border-secondary shadow" style="height: 400px;">
                <div class="mh-100 vh-100 overflow-auto ">
                  <ul class="list-group">
                  <li v-for="item in dataRemarklists" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                      <span class="text-start">{{item.Remark}}</span>
                      <span class="btn badge bg-primary rounded-pill" title="เพิ่ม"  @click="addRemark(item.Remark)">Add</span>
                  </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'LabResult2Entry',
  data () {
    return {
      editRecordID: null,
      arrSex: ['', 'ชาย', 'หญิง'],
      headerMoreON: false,
      curRowIndexDtl: 0,
      datalists: [],
      curRecordHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PrefixName: '',
        PatName: '',
        PatLName: '',
        IDNo: '',
        Sex: 0,
        AgeYears: 0,
        AgeMonths: 0,
        ReqClinicID: 0,
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        Specimen: '',
        Remark: '',
        Status: 0
      },
      maxLenRemark: 4000,
      // รายการตัวเลือกของประเภทข้อมูลแบบข้อความ เปลี่ยนไปตามแต่ละเทส
      dataPreResultlists: ''
    }
  },
  mounted () {
    this.curRecordHd.ROID = this.dataROHead.ROID
    this.curRecordHd.RONo = this.dataROHead.RONo
    this.curRecordHd.PrefixName = this.dataROHead.PrefixName
    this.curRecordHd.PatName = this.dataROHead.PatName
    this.curRecordHd.PatLName = this.dataROHead.PatLName
    this.curRecordHd.IDNo = this.dataROHead.IDNo
    this.curRecordHd.Sex = this.dataROHead.Sex
    this.curRecordHd.AgeYears = this.dataROHead.AgeYears
    this.curRecordHd.AgeMonths = this.dataROHead.AgeMonths
    this.curRecordHd.Remark = this.dataROHead.Remark

    this.curRecordHd.Weight = this.dataROHead.Weight
    this.curRecordHd.Height = this.dataROHead.Height
    this.curRecordHd.Pulse = this.dataROHead.Pulse
    this.curRecordHd.BodyTemp = this.dataROHead.BodyTemp
    this.curRecordHd.BP_1 = this.dataROHead.BP_1
    this.curRecordHd.BP_2 = this.dataROHead.BP_2
    this.curRecordHd.SpO2 = this.dataROHead.SpO2
    this.curRecordHd.Specimen = this.dataROHead.Specimen
    this.getLabResultData()
  },
  components: {

  },
  props: ['dataROHead', 'dataRemarklists'],
  computed: {
    // จำนวนตัวอักษรที่เหลือของ หมายเหตุ (สูงสุด 4000)
    _RemarkCharsCnt: function () {
      //
      const lenBal = this.maxLenRemark - this.curRecordHd.Remark.length
      return lenBal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    // คำนวณค่า eGFR ตามสูตร GFR(CKD-EPI formula)
    calculate_eGFR (datalists, index) {
      // ตรวจอายุต้องมากกว่า 18 ปี
      if (this.curRecordHd.AgeYears < 18) {
        Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เพราะคนไข้อายุน้อยกว่า 18 ปี' })
      } else {
        const nAge = this.curRecordHd.AgeYears
        let nCr = 0
        let bCrExist = false
        let neGFR = 0
        for (let i = 0; i < datalists.length; i++) {
          if (datalists[i].ItemTestID === this.globalCorpInfo.Cr_ID) {
            nCr = datalists[i].Result
            bCrExist = true
          }
        }
        // มีค่า Cr ในใบสั่งตรวจ
        if (bCrExist && nCr > 0) {
          if ((this.curRecordHd.Sex === 1) || (this.curRecordHd.Sex === '1')) {
            // ชาย
            if (nCr <= 0.9) {
              neGFR = 141 * (nCr / 0.9) ** -0.411 * (0.993 ** nAge) // Cr <= 0.9
            } else {
              neGFR = 141 * (nCr / 0.9) ** -1.209 * (0.993 ** nAge) // Cr >  0.9
            }
            this.datalists[index].Result = Number.parseFloat(neGFR).toFixed(2)
          } else if ((this.curRecordHd.Sex === 2) || (this.curRecordHd.Sex === '2')) {
            // หญิง
            if (nCr <= 0.7) {
              neGFR = 144 * (nCr / 0.7) ** -0.329 * (0.993 ** nAge) // Cr <= 0.7
            } else {
              neGFR = 144 * (nCr / 0.7) ** -1.209 * (0.993 ** nAge) // Cr >  0.7
            }
            this.datalists[index].Result = Number.parseFloat(neGFR).toFixed(2)
          } else {
            Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ กรุณาระบุเพศในข้อมูลคนไข้!!' })
          }
        } else {
          Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ ไม่ทราบค่า Serum creatinine!!' })
        }
      }
    },
    // A/G Raio = Albumin / (Total_protein - Albumin)
    calculate_AGRatio (datalists, index) {
      let nAlbumin = 0
      let nTotalProtein = 0
      let bAlbuminExist = false
      let bTotalProteinExist = false
      let nAGRatio = 0 // Cacl this
      for (let i = 0; i < datalists.length; i++) {
        if (datalists[i].ItemTestID === this.globalCorpInfo.Albumin_ID) {
          nAlbumin = datalists[i].Result
          bAlbuminExist = true
        }
        if (datalists[i].ItemTestID === this.globalCorpInfo.TotalProtein_ID) {
          nTotalProtein = datalists[i].Result
          bTotalProteinExist = true
        }
      }
      // มีค่า HbA1c ในใบสั่งตรวจ
      if (bAlbuminExist && nAlbumin > 0) {
        if (bTotalProteinExist && nTotalProtein > 0) {
          nAGRatio = nAlbumin / (nTotalProtein - nAlbumin)
          this.datalists[index].Result = Number.parseFloat(nAGRatio).toFixed(2)
        } else {
          Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เนื่องจาก.. [TotalProtein] not exist หรือ ไม่ทราบค่า [TotalProtein]!!' })
        }
      } else {
        Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เนื่องจาก.. [Albumin] not exist หรือ ไม่ทราบค่า [Albumin]!!' })
      }
    },

    // คำนวณค่า LDL ตามสูตร LDL = TC - HDL - (TG/5) ; Only if TG < 400 mg/ml
    calculate_LDL (datalists, index) {
      let nTC = 0
      let nHDL = 0
      let nTG = 0
      let bTCExist = false
      let bHDLExist = false
      let bTGExist = false
      let nLDL = 0 // Cacl this
      for (let i = 0; i < datalists.length; i++) {
        if (datalists[i].ItemTestID === this.globalCorpInfo.TC_ID) {
          nTC = datalists[i].Result
          bTCExist = true
        }
        if (datalists[i].ItemTestID === this.globalCorpInfo.HDL_ID) {
          nHDL = datalists[i].Result
          bHDLExist = true
        }
        if (datalists[i].ItemTestID === this.globalCorpInfo.TG_ID) {
          nTG = datalists[i].Result
          bTGExist = true
        }
      }
      // มีค่า TG ในใบสั่งตรวจ
      if (bTGExist && nTG < 400) {
        if (bTCExist && nTC > 0) {
          if (bHDLExist && nHDL > 0) {
            if (bTGExist && nTG > 0) {
              nLDL = nTC - nHDL - (nTG / 5)
              this.datalists[index].Result = Number.parseFloat(nLDL).toFixed(2)
            } else {
              Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เนื่องจาก.. [Triglyceride] not exist or [Triglyceride] = 0 !!' })
            }
          } else {
            Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เนื่องจาก.. [HDL] not exist or [HDL] = 0 !!' })
          }
        } else {
          Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เนื่องจาก.. [Total Cholesterol] not exist or [Total Cholesterol] = 0 !!' })
        }
      } else {
        Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เนื่องจาก.. [Triglyceride] not exist or [Triglyceride] >= 400 mg/ml !!' })
      }
    },
    // คำนวณค่า eAG ตามสูตร : eAG = (28.7* HbA1c) -  46.7
    calculate_eAG (datalists, index) {
      let nHbA1c = 0
      let bHbA1cExist = false
      let neAG = 0 // Cacl this
      for (let i = 0; i < datalists.length; i++) {
        if (datalists[i].ItemTestID === this.globalCorpInfo.HbA1C_ID) {
          nHbA1c = datalists[i].Result
          bHbA1cExist = true
        }
      }
      // มีค่า HbA1c ในใบสั่งตรวจ
      if (bHbA1cExist && nHbA1c > 0) {
        neAG = (28.7 * nHbA1c) - 46.7
        this.datalists[index].Result = Number.parseFloat(neAG).toFixed(2)
      } else {
        Swal.fire({ icon: 'error', text: 'ไม่สามารถคำนวณได้ เนื่องจาก.. HbA1c not exist หรือ ไม่ทราบค่า HbA1c!!' })
      }
    },
    // Differential WBC Count = 100% ?
    calculate_DiffWBC_Chk100 (datalists, index) {
      let nNeut = 0
      let nEosi = 0
      let nBaso = 0
      let nLymp = 0
      let nMono = 0
      let bNeutExist = false
      let bEosiExist = false
      let bBasoExist = false
      let bLympExist = false
      let bMonoExist = false

      let nSum100 = 0 // Cacl sum(all) must = 100
      for (let i = 0; i < datalists.length; i++) {
        if (datalists[i].ItemTestID === this.globalCorpInfo.Neutrophil_ID) {
          nNeut = parseFloat(datalists[i].Result)
          bNeutExist = true
        }
        if (datalists[i].ItemTestID === this.globalCorpInfo.Eosinophil_ID) {
          nEosi = parseFloat(datalists[i].Result)
          bEosiExist = true
        }
        if (datalists[i].ItemTestID === this.globalCorpInfo.Basophil_ID) {
          nBaso = parseFloat(datalists[i].Result)
          bBasoExist = true
        }
        if (datalists[i].ItemTestID === this.globalCorpInfo.Lymphocyte_ID) {
          nLymp = parseFloat(datalists[i].Result)
          bLympExist = true
        }
        if (datalists[i].ItemTestID === this.globalCorpInfo.Monocyte_ID) {
          nMono = parseFloat(datalists[i].Result)
          bMonoExist = true
        }
      }
      // มีค่า WBC ในใบสั่งตรวจ
      if (bNeutExist || bEosiExist || bBasoExist || bLympExist || bMonoExist) {
        nSum100 = nNeut + nEosi + nBaso + nLymp + nMono
        if (nSum100 === 100) {
          Swal.fire({ position: 'top-end', icon: 'success', title: '100% - PASS', showConfirmButton: false, timer: 1500 })
        } else {
          Swal.fire({ icon: 'error', title: nSum100, text: 'ผลรวมของ Differential WBC ไม่เท่ากับ 100!!' })
        }
      } else {
        Swal.fire({ icon: 'error', text: 'ไม่ตรวจสอบค่าได้ เนื่องจาก.. ไม่พบ Differential WBC   ' })
      }
    },

    // ลบรายการเทส เพื่อ initial ใหม่
    clearAllItemsLabResult () {
      var self = this
      Swal.fire({
        title: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        text: 'ข้อมูลผลแล็บจะถูกลบออกทุกรายการ เพื่อเริ่มต้น initial ใหม่',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/clear_items_labresult.php',
            data: { id: self.curRecordHd.ROID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              // รีเฟรชตาราง
              self.getLabResultData()
            })
          })
        }
      })
    },
    addPreResult (str) {
      let comma = ''
      if (this.datalists[this.curRowIndexDtl].ResultText.length > 0) {
        comma = ', '
      }
      this.datalists[this.curRowIndexDtl].ResultText = this.datalists[this.curRowIndexDtl].ResultText + comma + str
    },
    btnAddPreResultClicked (index, listPreResult) {
      this.curRowIndexDtl = index
      this.dataPreResultlists = listPreResult
    },
    clearTextResultAll (index) {
      this.datalists[index].ResultText = ''
    },
    saveAllRows () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม เป็น Array of Obj
      var rows = []
      $('#formRowsToEditTable').find('.my-edit-tr').each(function (i, element) {
        var inputObj = {}
        $(element).find('.my-edit-input').each(function (index, data) {
          $.extend(inputObj, { [data.name]: data.value })
        })
        rows.push(inputObj)
        // console.log(rows)
      })
      // console.log(self.curRecordHd)
      // console.log('CHECK VALUE : ')
      // console.log(rows)
      // console.log(JSON.stringify(this.datalists))
      // บันทึกลงฐานข้อมูล โดยเรียก API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_ro_labresult.php',
        data: {
          ROID: self.curRecordHd.ROID,
          UserID: self.globalUserID,
          Remark: self.curRecordHd.Remark,
          request: JSON.stringify(this.datalists)
          // request: JSON.stringify(rows)
        }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            self.backPageAfterSave()
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    itemsOfValueList (textArr) {
      return textArr.split(',')
    },
    // Insert เทสทั้งหมดเข้าไปในใบสั่งตรวจ
    initialItemsLabResult () {
      var self = this
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_ro_labresult.php',
        data: { ROID: self.curRecordHd.ROID }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'เตรียมข้อมูลสำหรับการบันทึกผลแล็บ..',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // Refresh >> this component only
            // this.$refs.getData()
            self.getLabResultData()
            // location.reload()
            // this.$router.push('MClinics')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถเตรียมข้อมูลได้' })
        })
    },
    getLabResultData () {
      // MyApiClient.get('getdata/labrequest_all.php')
      MyApiClient.get('getdata/labresult_where.php?id=' + this.curRecordHd.ROID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            this.datalists = []
          }
        //   setTimeout(function () { $('#myEntryResultTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    headerMoreONOFF () {
      this.headerMoreON = !this.headerMoreON
    },
    backPage () {
      this.$emit('onBackPageEvent')
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    },
    addRemark (str) {
      var taRemark = this.$refs.taRemark
      var curPos = taRemark.selectionStart

      this.curRecordHd.Remark =
        this.curRecordHd.Remark.slice(0, curPos) +
        str +
        this.curRecordHd.Remark.slice(curPos)
      // this.curRecordHd.Remark = this.curRecordHd.Remark + str
    }
  }
}
</script>

<style>

</style>
